import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "BuildPilot App | Australia's Building Intelligence Platform",
  description = "Australia's independent building intelligence platform. Practical tools and expert guidance to help you make better building decisions.",
  url,
  image = "https://www.buildpilot.app/buildpilot-app-social-preview.png",
  type = "website",
  keywords = "",
  schema
}) => {
  const location = useLocation();
  // Strip trailing slash (except root) so canonicals match sitemap entries
  const cleanPath = location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '');
  const canonicalUrl = url || `https://www.buildpilot.app${cleanPath}`;

  useEffect(() => {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.content = description;

    const ogTags = { 'og:title': title, 'og:description': description, 'og:url': canonicalUrl, 'og:image': image, 'og:type': type };
    Object.entries(ogTags).forEach(([prop, content]) => {
      const el = document.querySelector(`meta[property="${prop}"]`);
      if (el) el.content = content;
    });

    const twitterTags = { 'twitter:title': title, 'twitter:description': description, 'twitter:url': canonicalUrl, 'twitter:image': image };
    Object.entries(twitterTags).forEach(([name, content]) => {
      let el = document.querySelector(`meta[property="${name}"]`) || document.querySelector(`meta[name="${name}"]`);
      if (el) el.content = content;
    });
  }, [title, description, canonicalUrl, image, type]);

  return (
    <Helmet>
      <title>{title}</title>
      {keywords && <meta name="keywords" content={keywords} />}
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};

export default SEO;
